// extracted by mini-css-extract-plugin
export default {"wrapper":"wy-z","viewport":"xy-z","container":"yy-z","slide":"zy-z"};